import React from "react";
import { observer, PropTypes } from "mobx-react";
import ContentItem from "shared/components/cms/ContentItem";
import map from "lodash/map";
import { ContentItemUtilities } from "shared/components/cms/ContentItem";

@observer
class CustomError extends React.Component {
    _getErrorMessageText(error, i) {
        if (error.errorMessageWithLoginLinkCmsKey) {
            const parts = error.errorMessageWithLoginLinkCmsKey.split("|");
            const cmsKey = parts[0];
            const url = parts[1];
            const contactFormatArgs = {
                LoginLink: ContentItemUtilities.stringifyComponent(
                    <a href={url} target="_blank">Log in here</a>
                )
            };
            return <ContentItem contentKey={cmsKey} key={i} stringFormatArgs={contactFormatArgs} />;
        }
        if (error.errorMessageCmsKey) {
            return <ContentItem contentKey={error.errorMessageCmsKey} key={i} />;
        }
        if (error.errorMessageText) {
            return <span key={i}>{error.errorMessageText}</span>;
        }
        return <span key={i}>{error}</span>;
    }

    render() {
        const hasErrors = this.props.errors && this.props.errors.length > 0;
        if (!hasErrors) {
            return null;
        }
        return (
            <div className="input-message error-message">
                {map(this.props.errors, (error, i) => this._getErrorMessageText(error, i))}
            </div>
        );
    }
}

CustomError.propTypes = {
    errors: PropTypes.observableArray
};

export default CustomError;
